
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  textRendering: "geometricPrecision",
  viewBox: "0 0 24 24"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABC1BMVEVMaXH0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf////0AHf0Anj7nsv+6/T//f71G4X1D3/7m8r//v76iMD9z+X1EYD7oMz+6vT2MpL2MZH7n8z1H4j3RJv90Ob9x+H91+r0C331DH32LI70AXj1GIT2OZX2M5L3Opb1GYT6ksX7qdH1FYL8vNv+8Pf2KIz3Ppj+5/L3UaL/+vz4Wqf4ZKz4VaT1Hof5ebj8sdX90+j2JYv5erj8w9/91un92Or2LY/2K472Ko31IIgdTFOCAAAAH3RSTlMA57t4AtY0HsNfd6Sj6gEsH7g1uekuLcHCU1LV2Nc2STVYEQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAASBJREFUeNpVUueagjAQDCoIKuh5vWYAQbGXs56n13vv7/8khyT5CPNrdifZTgiHliukUoWcRhLIGCqms05nNoVqZGJ/Vsev06IhWs4P9KzwF5VRtUI5KtWRUuTvN7w6lVD3zOiPte1/Ro7jIAguV2To61Yo7KHLXi4BRIloE0Yo7HdqTDgDbJaq1j4M64fDY18A55w60Ejadrk1AK44de00yfdENTfAteC9PFk7EcYdcCv46bok0AYeJCEORd/wLuhfXkpOnx9fpORxuRIcHBGitnmDr/3+PeUNHoSd76LJzA/giUojsXb8IRtio/EdkS9fj5ZVMpNjH3hmiS1kSxnLixorm9JqJ92oarc7kVbLjsFezOcLO3kMK5TZ+ZSF4x+hWTxxK8d8dgAAAABJRU5ErkJggg==",
  width: 24,
  height: 24,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABC1BMVEVMaXH0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf////0AHf0Anj7nsv+6/T//f71G4X1D3/7m8r//v76iMD9z+X1EYD7oMz+6vT2MpL2MZH7n8z1H4j3RJv90Ob9x+H91+r0C331DH32LI70AXj1GIT2OZX2M5L3Opb1GYT6ksX7qdH1FYL8vNv+8Pf2KIz3Ppj+5/L3UaL/+vz4Wqf4ZKz4VaT1Hof5ebj8sdX90+j2JYv5erj8w9/91un92Or2LY/2K472Ko31IIgdTFOCAAAAH3RSTlMA57t4AtY0HsNfd6Sj6gEsH7g1uekuLcHCU1LV2Nc2STVYEQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAASBJREFUeNpVUueagjAQDCoIKuh5vWYAQbGXs56n13vv7/8khyT5CPNrdifZTgiHliukUoWcRhLIGCqms05nNoVqZGJ/Vsev06IhWs4P9KzwF5VRtUI5KtWRUuTvN7w6lVD3zOiPte1/Ro7jIAguV2To61Yo7KHLXi4BRIloE0Yo7HdqTDgDbJaq1j4M64fDY18A55w60Ejadrk1AK44de00yfdENTfAteC9PFk7EcYdcCv46bok0AYeJCEORd/wLuhfXkpOnx9fpORxuRIcHBGitnmDr/3+PeUNHoSd76LJzA/giUojsXb8IRtio/EdkS9fj5ZVMpNjH3hmiS1kSxnLixorm9JqJ92oarc7kVbLjsFezOcLO3kMK5TZ+ZSF4x+hWTxxK8d8dgAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 24 24\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABC1BMVEVMaXH0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf////0AHf0Anj7nsv+6/T//f71G4X1D3/7m8r//v76iMD9z+X1EYD7oMz+6vT2MpL2MZH7n8z1H4j3RJv90Ob9x+H91+r0C331DH32LI70AXj1GIT2OZX2M5L3Opb1GYT6ksX7qdH1FYL8vNv+8Pf2KIz3Ppj+5/L3UaL/+vz4Wqf4ZKz4VaT1Hof5ebj8sdX90+j2JYv5erj8w9/91un92Or2LY/2K472Ko31IIgdTFOCAAAAH3RSTlMA57t4AtY0HsNfd6Sj6gEsH7g1uekuLcHCU1LV2Nc2STVYEQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAASBJREFUeNpVUueagjAQDCoIKuh5vWYAQbGXs56n13vv7/8khyT5CPNrdifZTgiHliukUoWcRhLIGCqms05nNoVqZGJ/Vsev06IhWs4P9KzwF5VRtUI5KtWRUuTvN7w6lVD3zOiPte1/Ro7jIAguV2To61Yo7KHLXi4BRIloE0Yo7HdqTDgDbJaq1j4M64fDY18A55w60Ejadrk1AK44de00yfdENTfAteC9PFk7EcYdcCv46bok0AYeJCEORd/wLuhfXkpOnx9fpORxuRIcHBGitnmDr/3+PeUNHoSd76LJzA/giUojsXb8IRtio/EdkS9fj5ZVMpNjH3hmiS1kSxnLixorm9JqJ92oarc7kVbLjsFezOcLO3kMK5TZ+ZSF4x+hWTxxK8d8dgAAAABJRU5ErkJggg==\" width=\"24\" height=\"24\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAABC1BMVEVMaXH0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf0AHf////0AHf0Anj7nsv+6/T//f71G4X1D3/7m8r//v76iMD9z+X1EYD7oMz+6vT2MpL2MZH7n8z1H4j3RJv90Ob9x+H91+r0C331DH32LI70AXj1GIT2OZX2M5L3Opb1GYT6ksX7qdH1FYL8vNv+8Pf2KIz3Ppj+5/L3UaL/+vz4Wqf4ZKz4VaT1Hof5ebj8sdX90+j2JYv5erj8w9/91un92Or2LY/2K472Ko31IIgdTFOCAAAAH3RSTlMA57t4AtY0HsNfd6Sj6gEsH7g1uekuLcHCU1LV2Nc2STVYEQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAASBJREFUeNpVUueagjAQDCoIKuh5vWYAQbGXs56n13vv7/8khyT5CPNrdifZTgiHliukUoWcRhLIGCqms05nNoVqZGJ/Vsev06IhWs4P9KzwF5VRtUI5KtWRUuTvN7w6lVD3zOiPte1/Ro7jIAguV2To61Yo7KHLXi4BRIloE0Yo7HdqTDgDbJaq1j4M64fDY18A55w60Ejadrk1AK44de00yfdENTfAteC9PFk7EcYdcCv46bok0AYeJCEORd/wLuhfXkpOnx9fpORxuRIcHBGitnmDr/3+PeUNHoSd76LJzA/giUojsXb8IRtio/EdkS9fj5ZVMpNjH3hmiS1kSxnLixorm9JqJ92oarc7kVbLjsFezOcLO3kMK5TZ+ZSF4x+hWTxxK8d8dgAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mark.0bf75e91b29d552e26f6494aa8b4623a.svg"),
        {
          React: SvgMark,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      